import React from 'react'
import ButtonNew from '../ButtonNew'
import { BUTTON_VARIANT } from '../ButtonNew/ButtonNew'
import RichText from '@/src/components/rich-text'
import { getUrl } from '@/src/utils/urls'
import { SiteDataContext } from '@/src/components'

const PricingCardSecondary = ({ card, slugPrefix }) => {
  const { isTextRtl } = React.useContext(SiteDataContext)

  return (
    <div dir={isTextRtl ? 'rtl' : 'ltr'} className="c-pricing-card-secondary">
      {card.title ? <h4 className="c-pricing-card-secondary__title">{card.title}</h4> : null}
      {card.description && (
        <div className="c-pricing-card-secondary__description">
          <RichText data={card.description} tokens={{}} />
        </div>
      )}
      {card.action && (
        <ButtonNew
          url={getUrl({
            navItem: card.action,
            slugPrefix: slugPrefix
          })}
          variant={BUTTON_VARIANT.PRIMARY}
          size="md"
          icon={'ti-circle-arrow-right'}
        >
          {card.action.title}
        </ButtonNew>
      )}
    </div>
  )
}

export default PricingCardSecondary
